import { render, staticRenderFns } from "./venteForm.vue?vue&type=template&id=1878a393&scoped=true"
import script from "./venteForm.vue?vue&type=script&lang=js"
export * from "./venteForm.vue?vue&type=script&lang=js"
import style0 from "./venteForm.vue?vue&type=style&index=0&id=1878a393&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878a393",
  null
  
)

export default component.exports